import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { ApptokenService } from 'shared/utils/apptoken.service';

@Injectable()
export class AppAuthService {

    logout(reload?: boolean, returnUrl?: string): void {
        new ApptokenService().clearToken();
        if (reload !== false) {
            if (returnUrl) {
                location.href = returnUrl;
            } else {
                location.href = AppConsts.appBaseUrl;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/auth/app-auth.service.ts